




import BaseComponent from "@/components/BaseComponent.vue";
import app from "@/app";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WCaptcha extends BaseComponent {
	@Prop({ type: String, required: true })
	captcha!: string;

	get src() {
		let service_url = app.url.get("OZ_SERVER_CAPTCHA_SERVICE");
		return `${service_url}/${this.captcha}`;
	}
}
